const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "CATO"
const desc =
  "CATO是一款可爱的平台解谜游戏，玩家需要一心二用，分别控制猫咪和吐司挑战谜题，二者合体甚至能进行悖论般的反重力翻滚跳跃！"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
}
